import { SENTRY_DOMAIN, SENTRY_MOBILE_DOMAIN } from 'shared/config'

const getReplaysPathByUserId = (id: number | string) =>
  `/organizations/sentry/replays/?query=user.id%3A${id}&statsPeriod=24h`

export const getSentryReplaysLinkByUserId = (id: number | string) => {
  if (!SENTRY_DOMAIN) return ''
  return `${SENTRY_DOMAIN}${getReplaysPathByUserId(id)}`
}

export const getSentryMobileReplaysLinkByUserId = (id: number | string) => {
  if (!SENTRY_MOBILE_DOMAIN) return ''
  return `${SENTRY_MOBILE_DOMAIN}${getReplaysPathByUserId(id)}`
}
